import styled from '@emotion/styled'
import { graphql, useStaticQuery } from 'gatsby'
import { Link } from './Link'
import * as React from 'react'
import ContentMargins from './ContentMargins';
import { getUrl } from './MenuSelector'


export function NavBar() {
  const data = useStaticQuery(graphql`
    query NavBarQuery {
      info: sanityIndexPage(_id: {eq: "main-index"}) {
        mainLinks {
          text,
          image {
            asset {
              fluid(maxWidth: 400) {
                ...GatsbySanityImageFluid
              }
            }
          },
          keypointLink {
            slug { current }
          },
          productPageLink {
            slug { current }
          },
          externalLink
        }
      }
    }
  `);

  return <NavBarStyled>
      <ContentMargins>
        <div className={"flex"}>
          {data.info.mainLinks.map(link => {
            const url = getUrl(link);
            return <Link to={url}>{link.text}</Link>;
          })}
        </div>
      </ContentMargins>
  </NavBarStyled>
}


const NavBarStyled = styled.div`
  background: #9B1030;
  color: white;
  overflow-x: auto; // On small mobile screens
    
  & .flex {
    display: flex;
    align-items: stretch;
    justify-content: stretch;
  }
  
  & a {
    text-decoration: none;
    color: inherit;
    font-weight: normal;
    padding: 5px 10px;
    display: block;
    flex: 1;
    white-space: nowrap;
    
    background: #9b1031;
    border-right: 1px solid white;
    &:first-child {
      border-left: 1px solid white;
    }
    &:hover {
      background: white;
      color: #9B1030;
    }
  }
`;